// Maps role → default landing page. Single source of truth.
export function homePathForRole(role) {
  if (role === "parent") return "/parent";
  if (role === "school_admin" || role === "teacher") return "/school";
  return "/dashboard";
}
